import * as actions from "./actionsType";

const initialData = {
  loading: false,
  saveLoading: false,
  competenciesFunLength: 0,
  competenciesFun: [],
  competenciesFunError: "",

  loadingTask: false,
  tasks: [],
  tasksLength: 0,
  tasksError: "",

  loadingCompetencies: false,
  competenciesLength: 0,
  competencies: [],
  competenciesError: "",

  formError: "",

};

export default function CompetencyFunReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_COMPETENCYFUN:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_COMPETENCYFUN:
      return { ...state, saveLoading: action.payload };
    case actions.GET_COMPETENCYFUN:
      return {
        ...state,
        competenciesFun: action.payload.competenciesFun,
        competenciesFunLength: action.payload.competenciesFunLength,
      };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.COMPETENCYFUN_FAIL:
      return { ...state, competenciesFunError: action.payload };

    //Competencias
    case actions.LOADING_COMPETENCY:
      return { ...state, loadingCompetencies: action.payload };

    case actions.GET_COMPETENCY:
      return {
        ...state,
        competencies: action.payload.competencies,
        competenciesLength: action.payload.competenciesLength,
      };

    case actions.COMPETENCY_FAIL:
      return { ...state, competenciesError: action.payload };

    //Funciones
    case actions.LOADING_TASK:
      return { ...state, loadingTask: action.payload };

    case actions.GET_TASKS:
      return {
        ...state,
        tasks: action.payload.tasks,
        tasksLength: action.payload.tasksLength,
      };
    case actions.TASK_FAIL:
      return { ...state, tasksError: action.payload };
    default:
      return state;
  }
}
